import React, { useEffect, useState } from 'react'
import { Form, Row, Col, Transfer, Tooltip, Modal, message } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import { LocalPersistence } from '../../../../factories';
import { SearchOutlined } from '@ant-design/icons';
import { updateRatePlan, deleteRatePlan} from '../../../../services/rateplan'
import {getOTACodes} from '../../../../services/common'
import PageContainer from '../../../CSIComponents/PageContainer';
import Loading from '../../../Loading';
import './tableDetail.css'
import ActionButtonsBar from '../../../ui/ActionButtonsBar'
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const TableDetailEdit = (props: {currentLine:any, setCurrentFlag: any, setCurrentLine: any }) => {
    const [form] = Form.useForm()
    const [transferData, setTransferData] = useState<Array<any>>([])
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([])
    const [data,setData] = useState<Array<any>>([])
    const [addLoading, setAddLoading] = useState(false)
    const [disabledStatus, setDisabledStatus] = useState(false)
    useEffect(() => {
        getTransferData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    // get transfer
    const getTransferData = async() => {
        setAddLoading(true)
        let res = await getOTACodes('TAG', '')
        setAddLoading(false)
        if (res&&res.otacodes&&res.otacodes.length!=0) {
            res.otacodes.map((item:any) => item.key = item.codeName)
            setTransferData(res.otacodes)
            setData(res.otacodes)
        } else {
            setTransferData([])
        }
    };

    const handleChange = (targetKeys:any) => {
        setTransferTargetKeys(targetKeys)
    }

    useEffect(() => {
        if (props.currentLine) {
            form.setFieldsValue({name: props.currentLine.name, code: props.currentLine.code, description: props.currentLine.description})
            props.currentLine.tags&&props.currentLine.tags!=''?setTransferTargetKeys(props.currentLine.tags.split(' | ')): setTransferTargetKeys([])
        } else {
            form.resetFields()
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [props.currentLine])

    const SaveClick = () => {
        (async () => {
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
                       
            form.validateFields().then( async(value) => {
                value.tags = transferTargetKeys.length!=0?transferTargetKeys.join(' | ') : ''
                value.rateplanid = props.currentLine.rateplanid
                value.rateplanlangid = props.currentLine.rateplanlangid
                const bodyQuery = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        rateplans: [value]
                    }
                }
                setAddLoading(true)
                const res =  await updateRatePlan(bodyQuery);
                if(res.result.success){
                    props.setCurrentLine(value)
                    props.setCurrentFlag('view')
                }else{
                    message.error({
                        content: res?.errors[0]?.message
                    });
                }
                setAddLoading(false)
                
            }).catch(err =>{})
        })()
    }
    const validateFieldsError = (changedValues:any,allValues:any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)
        }).catch(() => {
            const detailErrNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
            if (detailErrNum === 0) {
                setDisabledStatus(false)
            } else {
                setDisabledStatus(true)
            }
        })
    }
    const ModalHead = () => {
        return (
            <div style={{position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'}}>Confirm</div>
        )
    }
    const DeleteClick = async() => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        Modal.confirm({
            title: <ModalHead />,
            transitionName: "",
            maskTransitionName: "",
            centered: true,
            icon: '',
            content:`Are you sure you want to delete ${props.currentLine.name} ?`,            
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk:  async() => {
                // deleteRatePlan
                const bodyQuery = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        rateplans: [
                            {
                                rateplanid: props.currentLine.rateplanid,
                                rateplanlangid: props.currentLine.rateplanlangid,
                            }
                        ]
                    }
                }
                const res =  await deleteRatePlan(bodyQuery);
                if(res.result.success){
                    props.setCurrentFlag('table')
                }else{
                    message.error({
                        content: res?.errors[0]?.message
                    });
                }
            },
            onCancel() {
                
            },
        });
        
    }

    const onSearchChange = (e:any) =>{
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        setTransferData(res)
    }

    if (addLoading) return <Loading type='large' />
    return (
        <PageContainer>
        <div style={{marginTop: -15, background: '#fff'}} className='ratePlan'>
            <p style={{fontWeight: 'bold', padding: '16px',color: '#333'}}>{props.currentLine.name}</p>
            <div style={{padding: '0 32px'}}>
                <Form
                        layout="vertical"
                        form={form}
                        name="basic"
                        initialValues={{ remember: true }}
                        onValuesChange= {validateFieldsError}
                    >
                    <Row>
                        <Col span={8}>
                            <Form.Item
                                label="Rate Plan Name"
                                name="name"
                                rules={[{
                                    required: true,
                                    message: 'This field is required'
                                    },
                                    {
                                        max: 1000,
                                        message: 'You have reached the max character length of 1000'
                                    }]}
                            >
                                <Input maxLength={1000} />
                            </Form.Item>
                        </Col>
                        <Col offset={2} span={8}>
                            <Form.Item
                                label="Rate Plan Code"
                                name="code"
                                rules={[{ required: true, message: 'This field is required' },{ max: 64, message: 'You have reached the max character length of 64' }]}
                            >
                                <Input maxLength={64} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={18}>
                            <Form.Item
                                name='description'
                                label="Description"
                                rules={[{ max: 1000, message: 'You have reached the max character length of 1000' }]}
                            >
                                <TextArea maxLength={1000} />
                            </Form.Item>
                        </Col>
                    </Row>
                    { isTagsDisplayed &&
                        <Row>
                            <Form.Item name='tags' label="Selected Tags">
                                <Input onChange={onSearchChange} style={{width: '300px'}} suffix={
                                    <Tooltip title="search">
                                        <SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                    </Tooltip>
                                } />
                                <Transfer
                                    dataSource={transferData}
                                    targetKeys={transferTargetKeys}
                                    onChange={handleChange}
                                    render={item => item.codeName}
                                />
                            </Form.Item>
                        </Row>
                    }
                </Form>
            </div>           
                </div>
                <ActionButtonsBar
                    onDelete={DeleteClick}
                    onCancel={() => { props.setCurrentFlag('view') }}
                    onSave={SaveClick}
                    disabledSave={disabledStatus}
                />
        </PageContainer>
    )
}


export default TableDetailEdit
